// Butikkene som selger varer og gir pristilbud, til utskrifter i ansatt-appen (prisoversikt).
// Speiler BUTIKKER i src/email/ordreEpost.js og selgerne i src/receipt/salgsbilag.js (backend);
// endres de, endres dette.
export const BUTIKK = {
  1: {
    navn: 'Sport 1 Røyken',
    selskap: 'Sport 1 Røyken AS',
    orgnr: '926 866 486',
    adresse: 'Bråsetveien 3, 3440 Røyken',
    epost: 'royken@sport1.no',
    telefon: '31 28 82 20',
  },
  2: {
    navn: 'Sport 1 Slemmestad',
    selskap: 'Sport 1 Slemmestad AS',
    orgnr: '926 866 559',
    adresse: 'Kirkealleen 1, 3470 Slemmestad',
    epost: 'slemmestad@sport1.no',
    telefon: '31 02 02 10',
  },
};

export const butikkFor = (butikkid) => BUTIKK[Number(butikkid) === 2 ? 2 : 1];
